import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/estimate/img/heading_achievement.png",
  alt: "買取実績",
  class: "full-width"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "ご依頼いただいた買い取り実績をご紹介", -1)
const _hoisted_4 = [
  _hoisted_3
]

import { ref, reactive } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import api from '@/estimate/api'
import { RecordList } from '@/estimate/components'
import { Record } from '@/estimate/models'

/** 買い取り実績一覧 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const recordList = ref<Record[]>([])

/** ページネーションデータ */
const pagination = reactive({
  sortBy: 'saleDay', // 初期ソートカラム
  descending: true, // 初期ソート順 降順=true 昇順=false
  page: 1,
  rowsPerPage: 6,
  rowsNumber: 0,
})

/** 廃車買い取り実績一覧取得タスク */
const getRecordTask = useAsyncTask(async (signal, query) => {
  return api.record.list(query).then(res => {
    recordList.value = res.recordList
    Object.assign(pagination, res.pagination)
  })
})

getRecordTask.perform({ filter: { publishFlg: true }, pagination })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, _hoisted_2, 2),
    _createElementVNode("p", {
      class: _normalizeClass(_ctx.$style.description)
    }, _hoisted_4, 2),
    _createVNode(_unref(RecordList), {
      data: recordList.value,
      class: "q-my-xl"
    }, null, 8, ["data"])
  ], 2))
}
}

})